import React from "react";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoUnknownAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import IncidentLogYesNoUnknownAnswerField from "./IncidentLogYesNoUnknownAnswerField.tsx";
import IncidentLogAffectedCountriesField from "./IncidentLogAffectedCountriesField.tsx";
import { showsAffectedCountries } from "./incidentLogCrossBorderImpactVisibility.ts";

export interface IncidentLogCrossBorderImpactFieldProps {
    answer?: YesNoUnknownAnswer | null;
    affectedCountryCodes: Array<string>;
    onAnswerChange: (answer: YesNoUnknownAnswer) => void;
    onAffectedCountriesChange: (countryCodes: Array<string>) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogCrossBorderImpactField(props: IncidentLogCrossBorderImpactFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <IncidentLogYesNoUnknownAnswerField
                label={translateString("crossBorderImpact")}
                answer={props.answer}
                onChange={props.onAnswerChange}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {showsAffectedCountries(props.answer, props.isPreview) && (
                <IncidentLogAffectedCountriesField
                    affectedCountryCodes={props.affectedCountryCodes}
                    onChange={props.onAffectedCountriesChange}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default IncidentLogCrossBorderImpactField;
